// Lucide icon: blocks (https://lucide.dev/icons/blocks)
import { Blocks } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAddOn = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <Blocks />
    </IconComponentStyled>
  )
}
